import { useEffect, type ReactNode } from "react";
import { createPortal } from "react-dom";

import { Icon } from "@/components/Icon";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

export function Modal({ open, onClose, title, description, children, footer }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      className="modal-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal card--ticks" role="dialog" aria-modal="true">
        <button
          className="btn btn--ghost"
          onClick={onClose}
          style={{ position: "absolute", top: 10, right: 10, padding: 4 }}
          aria-label="Cerrar"
        >
          <Icon.X />
        </button>
        <div className="modal__head">
          <h3>{title}</h3>
          {description && <p>{description}</p>}
        </div>
        <div>{children}</div>
        {footer && <div className="modal__foot">{footer}</div>}
      </div>
    </div>,
    document.body,
  );
}
